/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Membershipfeelowerthan203Inputs */

const de__field_membershipfeelowerthan203 = /** @type {(inputs: _Field_Membershipfeelowerthan203Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wünscht niedrigeren Mitgliedsbeitrag`)
};

/**

* @param {_Field_Membershipfeelowerthan203Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_membershipfeelowerthan203 = /** @type {((inputs?: _Field_Membershipfeelowerthan203Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Membershipfeelowerthan203Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_membershipfeelowerthan203(inputs)
});
export { _field_membershipfeelowerthan203 as "_field_membershipFeeLowerThan20" }